import React from "react";

import { SkillsDelta } from "./charts/skills_delta";
import { SkillsHistChart } from "./charts/skills_hist_chart";
import { SkillsProfileSection } from "./charts/skills_profile_section";
import { SupplyTotalDemandSection } from "./charts/supply_total_demand_section";
import { SkillsUtilization } from "./skills_utilization/skills_utilization";

const SkillsPage = () => (
  <>
    <SkillsDelta />
    <SupplyTotalDemandSection />
    <SkillsHistChart />
    <SkillsProfileSection />
    <SkillsUtilization />
  </>
);

export default SkillsPage;
